export default {
  title: "FraudVision 项目目录".toUpperCase(),
  rating: "评分".toUpperCase(),
  rating_changes: "评分变动".toUpperCase(),
  medals: "勋章".toUpperCase(),
  description: "简介".toUpperCase(),

  ///////////
  brief: "信息速览".toUpperCase(),
  brief_category: "category".toUpperCase(),
  brief_meaning: "meaning".toUpperCase(),
  brief_score: "score".toUpperCase(),

  brief_category_audience: "audience".toUpperCase(),
  brief_category_activeness: "activennes".toUpperCase(),
  brief_category_botting: "botting".toUpperCase(),
  brief_category_networking: "networking".toUpperCase(),
  brief_category_effective_of_promotions: "effectiveness of promotions".toUpperCase(),
  brief_category_moderation: "moderation".toUpperCase(),
  brief_category_organicity: "organicity".toUpperCase(),
  brief_category_admins: "admins".toUpperCase(),
  brief_category_knowledge_sharing: "knowledge sharing".toUpperCase(),
  brief_category_additions: "additions".toUpperCase(),
  /////////
  rules: "群规".toUpperCase(),
  admins: "管理团队".toUpperCase(),

  admin: {
    view_account: "查看账号".toUpperCase(),
  },
}
